import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "70f42512-e23a-4011-a4c6-75b21220bd33",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    orientation: "vertical",
    type: "number",
    prefixText: "Input numerical answer",
    unit: "A",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 1.5,
};
